import React from "react"

const GlassesIcon = ({ color = "#000000" }) => {
    return (
        <svg
            fill={color}
            xmlns="http://www.w3.org/2000/svg"
            width="800px"
            height="800px"
            viewBox="0 0 16 16"
        >
            <path
                d="m15.86 9.16-1.43-5.31a1.88 1.88 0 0 0-1.81-1.37h-.44v1.26h.44a.63.63 0 0 1 .6.46L14 7.06a3.9 3.9 0 0 0-1.71-.39 3.64 3.64 0 0 0-3.7 3H7.42a3.64 3.64 0 0 0-3.7-3A3.87 3.87 0 0 0 2 7.06l.78-2.86a.63.63 0 0 1 .6-.46h.44V2.48h-.44a1.88 1.88 0 0 0-1.81 1.37L.14 9.16a3.19 3.19 0 0 0-.14.94 3.59 3.59 0 0 0 3.72 3.42 3.71 3.71 0 0 0 3.62-2.59h1.32a3.71 3.71 0 0 0 3.62 2.59A3.59 3.59 0 0 0 16 10.1a3.19 3.19 0 0 0-.14-.94zm-12.14 3.1a2.33 2.33 0 0 1-2.46-2.16 2.33 2.33 0 0 1 2.46-2.17 2.34 2.34 0 0 1 2.47 2.17 2.34 2.34 0 0 1-2.47 2.16zm8.56 0a2.34 2.34 0 0 1-2.47-2.16 2.34 2.34 0 0 1 2.47-2.17 2.33 2.33 0 0 1 2.46 2.17 2.33 2.33 0 0 1-2.46 2.16z"
            />
        </svg>
    )
}

export default GlassesIcon
